import React, {FC, useEffect, useState} from 'react';

import {dispatch} from 'store';
import {getStripePrices, setBillingType, setCurrentStripePrice, setRefreshToken, setTemporary} from 'modules/auth/actions';
import {getUserInfo} from 'modules/user/actions';

import {Button} from 'views/components';

import {history} from 'services/history';
import {useQuery} from 'utils';
import styles from './UpgradePlan.module.css';
import {t, getCurrencySymbol} from 'utils';
import texts from './texts';
import { useSelector } from 'react-redux';
import { RootState } from 'types';
import { Api } from 'services/api';
import { privatePolicyLink, termsCondition } from 'config';

export const UpgradeEUOnlinePlan: FC = () => {
  const [isGermany, setIsGermany] = useState(false);
  const [isNL, setIsNL] = useState(false);
  const [isOIEU, setIsOIEU] = useState(false);
  const [isUK, setIsUK] = useState(false);
  const {stripePrices} = useSelector((state: RootState) => state.auth);
  const {currencyType, userInfo} = useSelector((state: RootState) => state.user);
  const refreshToken = useQuery().get('token' || '');
  const apiToken = Api.getAxios().defaults.headers.Authorization ? true : false;

  useEffect(() => {
    localStorage.clear();
  }, [])

  useEffect(() => {
    if(userInfo && userInfo.country && userInfo.country.length) {
      switch(userInfo.country[0].short_name) {
        case 'DE':
          setIsGermany(true);
          return
          break;
        case 'NL':
          setIsNL(true);
          return
          break;
        case 'EU':
          setIsOIEU(true);
          return
          break;
        case 'UK':
          setIsUK(true);
          return
          break;
          default:
            return
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (refreshToken) {
      dispatch(setRefreshToken(refreshToken));
      dispatch(getUserInfo.request());
    }
  }, [refreshToken]);

  useEffect(() => {
    if (currencyType && apiToken) {
      dispatch(getStripePrices.request());
    }
  }, [currencyType, apiToken]);


  const stripePricesMonthly: any = [];

  stripePrices.map(el => {
    if (el.billing_type === 'monthly') {
      stripePricesMonthly.push(el);
  }
});
  

//   const prices = stripePrices && stripePrices.filter(i => i.billing_type === 'monthly')
// const oneCamera = prices && prices.find(i => i.nickname === '1 camera');
// const twoCameras = prices && prices.find(i => i.nickname === '2 cameras');
// const fivePrice = prices && prices.find(i => i.nickname === '5 cameras');
const currencySymbol = getCurrencySymbol(       
  stripePrices && 
  stripePrices.length &&
  stripePrices[0].currency ||'eur');

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrap}>
          <div className={styles.header}>
            <span className={styles.headerTitle}>
              {/*TODO i18*/}
              {t(texts.upgradePlan.title)}
            </span>
            <p className={styles.headerSub}>{t(texts.upgradePlan.subTitle)}</p>
          </div>
        <div className={styles.plans}>
          <div className={styles.plan}>
            <p className={styles.planType}>{t(texts.upgradePlan.single)}</p>
            <p className={styles.planName} style={{paddingRight: '10px'}}>1 {t(texts.upgradePlan.cameraLicence)}</p>
            <p className={styles.planPrice}>
              <span>
                {currencySymbol.icon}
                {/* {oneCamera?.price || '219'}</span>/mo */}
                {currencySymbol.name==='gbp' ? '188' : '219'}</span>/{
                  (isUK || isOIEU) ? <>{t(texts.upgradePlan.monthShort)}</> : <>{t(texts.upgradePlan.month)}</>
                
                }
            </p>
            <p className={styles.planDesc}>
              {t(texts.upgradePlan.annuallySave)} 
              {
                isGermany ? (
                  <>
                  &nbsp;
                  {currencySymbol.name==='gbp' ? '52' : '60'}
              {isNL && ',-'}
                  &nbsp;
              {currencySymbol.icon}
                  </>
                ) : (
                  <>
                  &nbsp;
              {currencySymbol.icon}
              &nbsp;
                  {currencySymbol.name==='gbp' ? '52' : '60'}
                  {isNL && ',-'}
                  
                  </>
                )
              }
              /
              {isGermany ? (
                <>
                 {t(texts.upgradePlan.monthUppCase)} 
                </>
              ) : (
                <>
                 {t(texts.upgradePlan.month)} 
                 </>
              )}
           
            </p>
            <div style={{ height: 1, backgroundColor: 'rgba(0,0,0,.1)' }} />
            <p className={styles.planDesc} style={{marginBottom: 69}}>
              {t(texts.upgradePlan.orPay)} 
              &nbsp;
              {currencySymbol.icon}
              &nbsp;
              {currencySymbol.name==='gbp' ? '240' : '279'} 
              &nbsp;
              {t(texts.upgradePlan.billedMonthly)}
            </p>
            <Button
            disabled
            disabledColor='#7E7D7D'
              color='#fff'
              title={t(texts.upgradePlan.select)}
              onClick={() => {
                dispatch(setBillingType('Monthly'));
                dispatch(setCurrentStripePrice(stripePricesMonthly[0]));
                history.push({
                pathname: 'plan',
                state: {
                  totalCameras: "1 camera",
                  type: 'Monthly'
                }
              })}
            }
            />
          </div>
          <div className={styles.plan}>
            <p className={styles.planType}>{t(texts.upgradePlan.multiple)}</p>
            <p className={styles.planName}>2-5 {t(texts.upgradePlan.cameraLicences)}</p>
            <p className={styles.planPrice}>
              {/* <span>{currencySymbol.icon}{twoCameras?.price || '199'}</span>/mo */}
              <span>{currencySymbol.icon}{currencySymbol.name==='gbp' ? '169' :  '199'}</span>/
              {(isUK || isOIEU) ? <>{t(texts.upgradePlan.monthShort)}</> : <>{t(texts.upgradePlan.month)}</>}
            </p>
            <p className={styles.planDesc}>
              {t(texts.upgradePlan.multipleSave)} {' '}
              {
                isGermany ? (
                  <>
                  50
                  &nbsp;
                  {currencySymbol.icon}
                 
                  /{t(texts.upgradePlan.monthUppCase)}
                  </>
                ): (
                  <>
                  &nbsp;
                  {currencySymbol.icon}
                  &nbsp;
                  {currencySymbol.name==='gbp' ? '45' : '50'}
                  {isNL && ',-'}
                  /{t(texts.upgradePlan.month)}
                  </>
                )
              }
             
            </p>

            <div style={{ height: 1, backgroundColor: 'rgba(0,0,0,.1)' }} />
            <p className={styles.planDesc} style={{marginBottom: 69}}>
              {t(texts.upgradePlan.orPay)} 
               &nbsp;
              {currencySymbol.icon}
              &nbsp;
              {currencySymbol.name==='gbp' ? '214' : '249'}
              {isUK && (<> {t(texts.upgradePlan.perCameraShort)}, </>)}
              &nbsp;
               {t(texts.upgradePlan.billedMonthlyMultiple)}
            </p>
            <Button
            disabled
            disabledColor='#7E7D7D'
            color='#fff'
              title={t(texts.upgradePlan.select)}
              onClick={() => {
                dispatch(setBillingType('Monthly'));
                dispatch(setCurrentStripePrice(stripePricesMonthly[1]));
                history.push({
                pathname: 'plan',
                state: {
                  totalCameras: "2 cameras",
                  type: 'Monthly',
                }
              })}
            }
            />
          </div>
          <div className={styles.plan}>
            <div className={styles.planSpecial}>
              
              {
                isNL ? (
                  <>
                  {t(texts.upgradePlan.specialOffer)}{' '}{new Date().getFullYear()}
                  </>
                ) : (
                  <>
                  {new Date().getFullYear() + ' '}{t(texts.upgradePlan.specialOffer)}
                  </>
                )
              }
            </div>
            <p className={styles.planName}>{t(texts.upgradePlan.upTo)} 5 {t(texts.upgradePlan.cameras)}</p>
            <p className={styles.planPrice}>
              {/* <span>{currencySymbol.icon}{fivePrice?.price || '199'}</span>/mo */}
              <span>{currencySymbol.icon}{currencySymbol.name==='gbp' ? '149' : '179'}</span>/
              {(isUK || isOIEU) ? <>{t(texts.upgradePlan.monthShort)}</> : <>{t(texts.upgradePlan.month)}</>}
            </p>
            <p className={styles.planDesc}>{t(texts.upgradePlan.perCamera)} 
            {
              isGermany ? (
                <>
              ,&nbsp;100&nbsp;
              {currencySymbol.icon}
              &nbsp;
              </>
              ) : (
                <>
                &nbsp;
                {currencySymbol.icon}
                {currencySymbol.name==='gbp' ? '52' : '60'}
                </>
              )
            }
             &nbsp;
              {t(texts.upgradePlan.upToLowerCase)} 
              &nbsp;
              {isGermany ? (
                <>
                {currencySymbol.name==='gbp' ? '225' : '250'}
                &nbsp;
                {currencySymbol.icon}&nbsp;/
                &nbsp;
                </>
              ) : (
                <>
                {currencySymbol.icon}
                &nbsp;
              {currencySymbol.name==='gbp' ? '225' : '250'}
              </>
              )
              }
              {isNL && ' , -/'}
              
              {isGermany ? (
                <>
                 {t(texts.upgradePlan.monthUppCase)} 
                </>
              ) : (
                <>
                 {(isUK || isOIEU) ? <>/{t(texts.upgradePlan.monthShort)}</> : <>{t(texts.upgradePlan.month)}</>} 
                 </>
              )}
              {isGermany && ' sparen'}
            </p>

            <div style={{ height: 0, backgroundColor: 'rgba(0,0,0,.1)' }} />
            <p className={styles.planDesc} style={{marginBottom: 69}}>
              {/* {t(texts.upgradePlan.orPay)} €249 {t(texts.upgradePlan.billedMonthly)} */}
            </p>
            <Button
              title={t(texts.upgradePlan.select)}
              bgColor='#fff'
              onClick={() => {
                dispatch(setBillingType('Monthly'));
                dispatch(setCurrentStripePrice(stripePricesMonthly[0]));
                history.push({
                pathname: 'plan',
                state: {
                  totalCameras: "5 cameras",
                  type: 'Monthly',
                  isFiveCameras: 'true'
                }
              })}
            }
            />
          </div>
          {/*<div className={styles.plan}>*/}
            {/*<p className={styles.planType}>{t(texts.upgradePlan.enterprise)}</p>*/}
            {/*<p className={styles.planName}>6+ {t(texts.upgradePlan.cameraLicences)}</p>*/}
            {/*<div style={{ height: 1, backgroundColor: 'rgba(0,0,0,.1)' }} />*/}

            {/*<p className={styles.planDesc}>{t(texts.upgradePlan.youHaveSix)}</p>*/}
            {/*<div style={{ flex: 1 }}></div>*/}
            {/*<div*/}
              {/*style={{*/}
                {/*display: 'flex',*/}
                {/*flex: 1,*/}
                {/*alignItems: 'flex-end',*/}
              {/*}}*/}
            {/*>*/}
              {/*<Button*/}
                {/*title={t(texts.upgradePlan.select)}*/}
                {/*onClick={() => history.push('enterprise-plan')}*/}
              {/*/>*/}
            {/*</div>*/}
          {/*</div>*/}
        </div>
        </div>
      <div className={styles.footer}>
        <p className={styles.footerText} style={{margin: '50px 0 0 0'}}>
          {currencySymbol.name === 'aud' && t(texts.upgradePlan.allPricesInAUD)}
          {currencySymbol.name === 'usd' && t(texts.upgradePlan.allPricesInUS)}
          {currencySymbol.name === 'eur' && t(texts.upgradePlan.allPricesInEUR)}
          {currencySymbol.name === 'gbp' && t(texts.upgradePlan.allPricesInGBP)}
          </p>
        <p className={styles.footerText} style={{margin: '10px 0 36px'}}>
          {t(texts.upgradePlan.termsText)}
          <a href={privatePolicyLink} target='_blank' className={styles.footerLink}>
            {t(texts.upgradePlan.privatePolicy)}
          </a>
          &nbsp;
          {t(texts.upgradePlan.and)}
          &nbsp;
          <a href={termsCondition} target='_blank' className={styles.footerLink}>
            {t(texts.upgradePlan.termsCondition)}
          </a>
        </p>
      </div>
    </div>
  );
};
